var PortalMetaCategory;
(function (PortalMetaCategory) {
  PortalMetaCategory["IMPORT_IMAGE_COPYRIGHT_NOTICE"] = "IMPORT_IMAGE_COPYRIGHT_NOTICE";
  PortalMetaCategory["SHUTTERSTOCK_TOS"] = "SHUTTERSTOCK_TOS";
  PortalMetaCategory["SHUTTERSTOCK_FOLDER_ID"] = "SHUTTERSTOCK_FOLDER_ID";
  PortalMetaCategory["DASHBOARD_ADVANCED_SEARCH_POPUP"] = "DASHBOARD_ADVANCED_SEARCH_POPUP";
  PortalMetaCategory["PICKER_ADVANCED_SEARCH_POPUP"] = "PICKER_ADVANCED_SEARCH_POPUP";
  PortalMetaCategory["VIDEO2_OPTIN_NOTICE"] = "VIDEO2_OPTIN_NOTICE";
})(PortalMetaCategory || (PortalMetaCategory = {}));
export default PortalMetaCategory;